export default __webpack_public_path__ + "static/media/hero-bg-t.e738338c.jpg";